import { render, staticRenderFns } from "./market-item-orders-table-item.vue?vue&type=template&id=1d99a9e9&scoped=true&"
import script from "./market-item-orders-table-item.vue?vue&type=script&lang=js&"
export * from "./market-item-orders-table-item.vue?vue&type=script&lang=js&"
import style0 from "./market-item-orders-table-item.vue?vue&type=style&index=0&id=1d99a9e9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d99a9e9",
  null
  
)

export default component.exports